export const ForestIcon = ({
  width = '24',
  height = '24',
  fill = '#0F2664',
}) => {
  return (
    <div className="feature">
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.99997 10V10.2C10.6558 10.4522 11.2023 10.9266 11.5442 11.5405C11.886 12.1544 12.0016 12.8687 11.8706 13.5591C11.7397 14.2494 11.3706 14.8719 10.8277 15.318C10.2848 15.7641 9.6026 16.0054 8.89997 16H4.99997C4.30574 15.9827 3.639 15.7251 3.11348 15.2712C2.58796 14.8172 2.2362 14.195 2.11821 13.5106C2.00022 12.8263 2.1233 12.1222 2.46646 11.5185C2.80962 10.9147 3.35161 10.4488 3.99997 10.2V10C3.99997 9.20435 4.31604 8.44129 4.87865 7.87868C5.44126 7.31607 6.20432 7 6.99997 7C7.79562 7 8.55868 7.31607 9.12129 7.87868C9.6839 8.44129 9.99997 9.20435 9.99997 10Z"
          stroke={fill}
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7 16V22"
          stroke={fill}
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13 19V22"
          stroke={fill}
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 19H20.3C20.4957 18.9973 20.6863 18.9371 20.8482 18.8271C21.0101 18.717 21.1361 18.5618 21.2106 18.3808C21.2851 18.1998 21.3049 18.001 21.2675 17.8088C21.23 17.6167 21.137 17.4398 21 17.3L18 14H18.3C18.4957 13.9973 18.6863 13.9371 18.8482 13.8271C19.0101 13.717 19.1361 13.5619 19.2106 13.3808C19.2851 13.1998 19.3049 13.001 19.2675 12.8088C19.23 12.6167 19.137 12.4398 19 12.3L16 9H16.2C16.4042 9.01843 16.6092 8.97361 16.7871 8.87162C16.9651 8.76963 17.1073 8.6154 17.1946 8.42984C17.282 8.24428 17.3101 8.03636 17.2753 7.83425C17.2405 7.63215 17.1444 7.44564 17 7.3L13 3L11.6 4.5"
          stroke={fill}
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};
